import React, { useLayoutEffect, useRef, useState } from "react";

const textFit = (el: HTMLDivElement, lineHeightOffset: number): boolean =>
  el.scrollHeight - lineHeightOffset <= el.clientHeight;

export type TextFitProps = {
  text: string;
  maxFontSize: number;
  maxHeight: number;
};

export const TextFit: React.FC<TextFitProps> = (
  props: TextFitProps
): React.JSX.Element => {
  const titleRef = useRef<HTMLDivElement>(null);
  const [fontSize, setFontSize] = useState<number>(props.maxFontSize);

  useLayoutEffect(() => {
    if (titleRef.current && !textFit(titleRef.current, 8)) {
      setFontSize(fontSize - 1);
    }
  }, [fontSize]);

  return (
    <div
      style={{
        fontSize: fontSize,
        maxHeight: props.maxHeight,
      }}
      ref={titleRef}
    >
      {props.text}
    </div>
  );
};
